import CrudService from "@/common/services/crud-service"
import User from "@/users/entities/user"

class UsersService extends CrudService<User> {
}

export default new UsersService("users")
